
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Landing/Header.vue';
import HeaderMobileAside from '@/components/Landing/HeaderMobileAside.vue';
import Footer from '@/components/Landing/Footer.vue';

@Component({
  components: {
    Header,
    HeaderMobileAside,
    Footer,
  },
})
export default class Main extends Vue {
}
